import * as React from "react";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import cancel from "../../assets/images/Frame 33970.png";
import {
  Box,
  Paper,
  Grid,
  Button,
  Tabs,
  Tab,
  List,
  ListItem,
  useTheme,
  useMediaQuery,
  Stack,
  Divider,
} from "@mui/material";
import BTE from "../../assets/images/Frame_34320[1].png";
import METALIC_RIC_OPTIMA from "../../assets/images/metalic_ric.svg";
import METALIC_LEFT_RIC_OPTIMA from "../../assets/images/metalic_left_ric.svg";
import METALIC_RIGHT_RIC_OPTIMA from "../../assets/images/metalic_right_ric.svg";
import BLACK_RIC_OPTIMA from "../../assets/images/black_ric.svg";
import BLACK_LEFT_RIC_OPTIMA from "../../assets/images/black_left_ric.svg";
import BLACK_RIGHT_RIC_OPTIMA from "../../assets/images/black_right_ric.svg";
import BEIGE_RIC_OPTIMA from "../../assets/images/beige_ric.svg";
import BEIGE_LEFT_RIC_OPTIMA from "../../assets/images/beige_left_ric.svg";
import BEIGE_RIGHT_RIC_OPTIMA from "../../assets/images/beige_right_ric.svg";

import METALIC_RIC_PRIME from "../../assets/images/metalic_ric.svg";
import METALIC_LEFT_RIC_PRIME from "../../assets/images/metalic_left_ric.svg";
import METALIC_RIGHT_RIC_PRIME from "../../assets/images/metalic_right_ric.svg";
import BLACK_RIC_PRIME from "../../assets/images/black_ric.svg";
import BLACK_LEFT_RIC_PRIME from "../../assets/images/black_left_ric.svg";
import BLACK_RIGHT_RIC_PRIME from "../../assets/images/black_right_ric.svg";
import BEIGE_RIC_PRIME from "../../assets/images/beige_ric.svg";
import BEIGE_LEFT_RIC_PRIME from "../../assets/images/beige_left_ric.svg";
import BEIGE_RIGHT_RIC_PRIME from "../../assets/images/beige_right_ric.svg";

import SPECS from "../../assets/images/SPECS Image.svg";
import LEFT from "../../assets/images/Frame 34481 (1).png";
import RIGHT from "../../assets/images/Frame 34483 (1).png";
import CENTER from "../../assets/images/Frame 34501 (1).png";
import RIGHTIMG from "../../assets/images/Left (1).png";
import LEFTIMG from "../../assets/images/Left (2).png";

import RIC_OPTIMA_16_RIGHT_POWER_MODE_GREY from "../../assets/images/RIC optima 16_Power Dome_right_grey.png";
import RIC_OPTIMA_16_RIGHT_POWER_MODE_BLACK from "../../assets/images/RIC optima 16_Power Dome_right_black.png";
import RIC_OPTIMA_16_RIGHT_POWER_MODE_BIEGE from "../../assets/images/RIC optima 16_Power Dome_right_Biege.png";

import RIC_OPTIMA_16_LEFT_POWER_MODE_GREY from "../../assets/images/RIC optima 16_Power Dome_left_grey.png";
import RIC_OPTIMA_16_LEFT_POWER_MODE_BLACK from "../../assets/images/RIC optima 16_Power Dome _left_black.png";
import RIC_OPTIMA_16_LEFT_POWER_MODE_BIEGE from "../../assets/images/RIC optima 16_Power Dome_left_Biege.png";

import RIC_OPTIMA_16_RIGHT_OPEN_MODE_GREY from "../../assets/images/RIC optima 16_Open Dome_right_grey.png";
import RIC_OPTIMA_16_RIGHT_OPEN_MODE_BLACK from "../../assets/images/RIC optima 16_Open Dome_right_black.png";
import RIC_OPTIMA_16_RIGHT_OPEN_MODE_BIEGE from "../../assets/images/RIC optima 16_Open Dome_right_beige.png";

import RIC_OPTIMA_16_LEFT_OPEN_MODE_GREY from "../../assets/images/RIC optima 16_Open Dome_left_grey.png";
import RIC_OPTIMA_16_LEFT_OPEN_MODE_BLACK from "../../assets/images/RIC optima 16_Open Dome_left_black.png";
import RIC_OPTIMA_16_LEFT_OPEN_MODE_BIEGE from "../../assets/images/RIC optima 16_Open Dome_left_beige.png";

import RIC_OPTIMA_16_RIGHT_CLOSE_MODE_GREY from "../../assets/images/RIC optima 16_Close Dome_right_grey.png";
import RIC_OPTIMA_16_RIGHT_CLOSE_MODE_BLACK from "../../assets/images/RIC optima 16_Close Dome_right_black.png";
import RIC_OPTIMA_16_RIGHT_CLOSE_MODE_BIEGE from "../../assets/images/RIC optima 16_Close Dome_right_Biege.png";

import RIC_OPTIMA_16_LEFT_CLOSE_MODE_GREY from "../../assets/images/RIC optima 16_Close Dome_left_grey.png";
import RIC_OPTIMA_16_LEFT_CLOSE_MODE_BLACK from "../../assets/images/RIC optima 16_Close Dome_left_black.png";
import RIC_OPTIMA_16_LEFT_CLOSE_MODE_BIEGE from "../../assets/images/RIC optima 16_Close Dome_left_Biege.png";

import RIC_OPTIMA_16_RIGHT_TULIP_MODE_GREY from "../../assets/images/RIC optima 16_Tulip Dome_right_grey.png";
import RIC_OPTIMA_16_RIGHT_TULIP_MODE_BLACK from "../../assets/images/RIC optima 16_Tulip Dome_right_black.png";
import RIC_OPTIMA_16_RIGHT_TULIP_MODE_BIEGE from "../../assets/images/RIC optima 16_Tulip Dome_right_Biege.png";

import RIC_OPTIMA_16_LEFT_TULIP_MODE_GREY from "../../assets/images/RIC optima 16_Tulip Dome_left_grey.png";
import RIC_OPTIMA_16_LEFT_TULIP_MODE_BLACK from "../../assets/images/RIC optima 16_Tulip Dome_left_black.png";
import RIC_OPTIMA_16_LEFT_TULIP_MODE_BIEGE from "../../assets/images/RIC optima 16_Tulip Dome_left_Biege.png";

import { useState } from "react";
import { Line } from "react-chartjs-2";
import {
  DEVICES,
  DEVICES_CHANNEL,
  DEVICES_TUBE,
  DOM_SIZE,
  DOM_TYPE,
  LISTENING_SIDE,
  DEVICE_COLORS,
} from "../../utils/patient.constants";
import LEFTARROWICON from "../../assets/images/leftIcon.svg";
import RIGHTARROWICON from "../../assets/images/rightarrow.svg";
import LetterAIcon from "../../assets/images/letter-a.svg";
import { useLocation } from "react-router-dom";
import ucl_left from "../../assets/images/ucl_left.svg";
import ucl_right from "../../assets/images/ucl_right.svg";

const Accordion = styled((props) => (
  <MuiAccordion
    sx={{ border: "1px solid #DDDDDD", borderRadius: "4px", padding: "" }}
    disableGutters
    elevation={0}
    square
    {...props}
  />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </Box>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const SelectDeviceui = ({ fields, setFields }) => {
  const { state } = useLocation();
  const [expanded, setExpanded] = useState("panel1");
  const [hovered, setHovered] = useState(false);
  const [hovered1, setHovered1] = useState(false);
  const [hovered2, setHovered2] = useState(false);
  const [hovered3, setHovered3] = useState(false);
  const [hovered4, setHovered4] = useState(false);
  const [hovered5, setHovered5] = useState(false);

  const [selectedTube, setSelectedTube] = useState(
    fields?.right_fitted_device?.device_tube
  );
  const [selectedDome, setSelectedDome] = useState(
    fields?.right_fitted_device?.dom_type
  );
  const [selectedTubeLeft, setSelectedTubeLeft] = useState(
    fields?.left_fitted_device?.device_tube
  );
  const [selectedDomeLeft, setSelectedDomeLeft] = useState(
    fields?.left_fitted_device?.dom_type
  );
  const [selectDevice, setSelectDevice] = useState(state ? state : null);
  const [value, setValue] = useState(0);
  const [values, setValues] = useState(0);
  const [values1, setValues1] = useState(0);
  const [device, setDevice] = useState(
    state
      ? state === LISTENING_SIDE.LEFT
        ? fields?.left_fitted_device?.device_type
          ? fields?.left_fitted_device?.device_type
          : DEVICES.BTE_PRIME
        : fields?.right_fitted_device?.device_type
        ? fields?.right_fitted_device?.device_type
        : DEVICES.BTE_PRIME
      : null
  );

  React.useEffect(() => {
    setFields((prevFields) => {
      let updatedFields = { ...prevFields };

      if (selectDevice === LISTENING_SIDE.LEFT) {
        updatedFields.left_fitted_device = {
          ...prevFields.left_fitted_device,
          device_channel:
            device === DEVICES.RIC_OPTIMA
              ? DEVICES_CHANNEL.CHANNEL_16
              : device === DEVICES.RIC_OPTIMA_8
              ? DEVICES_CHANNEL.CHANNEL_8
              : device === DEVICES.BTE_OPTIMA
              ? DEVICES_CHANNEL.CHANNEL_8
              : DEVICES_CHANNEL.CHANNEL_32,
          device_color:
            prevFields.left_fitted_device.device_color ?? DEVICE_COLORS.METALIC,
        };
      } else if (selectDevice === LISTENING_SIDE.RIGHT) {
        updatedFields.right_fitted_device = {
          ...prevFields.right_fitted_device,
          device_channel:
            device === DEVICES.RIC_OPTIMA
              ? DEVICES_CHANNEL.CHANNEL_16
              : device === DEVICES.RIC_OPTIMA_8
              ? DEVICES_CHANNEL.CHANNEL_8
              : device === DEVICES.BTE_OPTIMA
              ? DEVICES_CHANNEL.CHANNEL_8
              : DEVICES_CHANNEL.CHANNEL_32,
          device_color:
            prevFields.right_fitted_device.device_color ??
            DEVICE_COLORS.METALIC,
        };
      } else {
        updatedFields.right_fitted_device = {
          ...prevFields.right_fitted_device,
          device_channel:
            device === DEVICES.RIC_OPTIMA
              ? DEVICES_CHANNEL.CHANNEL_16
              : device === DEVICES.RIC_OPTIMA_8
              ? DEVICES_CHANNEL.CHANNEL_8
              : device === DEVICES.BTE_OPTIMA
              ? DEVICES_CHANNEL.CHANNEL_8
              : DEVICES_CHANNEL.CHANNEL_32,
          device_color:
            prevFields.right_fitted_device.device_color ??
            DEVICE_COLORS.METALIC,
        };
        updatedFields.left_fitted_device = {
          ...prevFields.left_fitted_device,
          device_channel:
            device === DEVICES.RIC_OPTIMA
              ? DEVICES_CHANNEL.CHANNEL_16
              : device === DEVICES.RIC_OPTIMA_8
              ? DEVICES_CHANNEL.CHANNEL_8
              : device === DEVICES.BTE_OPTIMA
              ? DEVICES_CHANNEL.CHANNEL_8
              : DEVICES_CHANNEL.CHANNEL_32,
          device_color:
            prevFields.left_fitted_device.device_color ?? DEVICE_COLORS.METALIC,
        };
      }

      return updatedFields;
    });
  }, [device, selectDevice]);

  const getDeviceFeatures = () => {
    if (device === DEVICES.RIC_OPTIMA || device === DEVICES.RIC_PRIME) {
      return [
        "Digital Sound Processor",
        "Wide Dynamic Range Compression",
        "Adaptive Noise Reduction Technology",
        "Bluetooth 5.0 Technology",
        "Wireless App Control with App fitting feature",
        "Adaptive Howling Suppression",
        "Smartphone/TV Streaming Support",
        "Up to 64 hours of Battery life with charging case",
      ];
    }

    return [
      "Device can program up to 8 channels.",
      "Two listening modes for different environments.",
      "High-end audio processing for noise reduction and clear sound.",
      "45 min. charging gives you up to 10 hrs. playtime.",
      "9 grams lightweight design with IPX6 water resistance.",
    ];
  };

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const handleChangeTab = (event, newValue) => {
    setValues(newValue);
  };
  const handleChangeTab1 = (event, newValue) => {
    setValues1(newValue);
  };

  const handleMouseOver = () => {
    setHovered(true);
  };

  const handleMouseOut = () => {
    setHovered(false);
  };

  const handleMouseOver1 = () => {
    setHovered1(true);
  };

  const handleMouseOut1 = () => {
    setHovered1(false);
  };

  const handleMouseOver2 = () => {
    setHovered2(true);
  };

  const handleMouseOut2 = () => {
    setHovered2(false);
  };

  const handleMouseOver3 = () => {
    setHovered3(true);
  };

  const handleMouseOut3 = () => {
    setHovered3(false);
  };
  const handleMouseOver4 = () => {
    setHovered4(true);
  };

  const handleMouseOut4 = () => {
    setHovered4(false);
  };

  const handleMouseOver5 = () => {
    setHovered5(true);
  };

  const handleMouseOut5 = () => {
    setHovered5(false);
  };

  const handleTubeClickRight = (tubeType) => {
    setFields({
      ...fields,
      right_fitted_device: {
        ...fields.right_fitted_device,
        device_tube: tubeType,
      },
    });
    setSelectedTube(tubeType);
  };

  const handleDomeClickRight = (domType) => {
    setFields({
      ...fields,
      right_fitted_device: {
        ...fields.right_fitted_device,
        dom_type: domType,
      },
    });
    setSelectedDome(domType);
  };

  const handleTubeClickLeft = (tubeType) => {
    setFields({
      ...fields,
      left_fitted_device: {
        ...fields.left_fitted_device,
        device_tube: tubeType,
      },
    });
    setSelectedTubeLeft(tubeType);
  };

  const handleDomeClickLeft = (domType) => {
    setFields({
      ...fields,
      left_fitted_device: {
        ...fields.left_fitted_device,
        dom_type: domType,
      },
    });
    setSelectedDomeLeft(domType);
  };

  const [selectedColorOptima, setSelectedColorOptima] = useState(
    fields?.right_fitted_device?.device_type === DEVICES.RIC_OPTIMA
      ? fields?.right_fitted_device?.device_color || DEVICE_COLORS.METALIC
      : DEVICE_COLORS.METALIC
  );

  const [selectedColorPrime, setSelectedColorPrime] = useState(
    fields?.right_fitted_device?.device_type === DEVICES.RIC_PRIME
      ? fields?.right_fitted_device?.device_color || DEVICE_COLORS.METALIC
      : DEVICE_COLORS.METALIC
  );

  const getRicOptimaImage = () => {
    switch (selectedColorOptima) {
      case DEVICE_COLORS.BLACK:
        return BLACK_RIC_OPTIMA;
      case DEVICE_COLORS.BEIGE:
        return BEIGE_RIC_OPTIMA;
      default:
        return METALIC_RIC_OPTIMA;
    }
  };

  const getRicPrimeImage = () => {
    switch (selectedColorPrime) {
      case DEVICE_COLORS.BLACK:
        return BLACK_RIC_PRIME;
      case DEVICE_COLORS.BEIGE:
        return BEIGE_RIC_PRIME;
      default:
        return METALIC_RIC_PRIME;
    }
  };

  const LEFT_EAR_IMAGES_OPTIMA = {
    [DEVICE_COLORS.METALIC]: METALIC_LEFT_RIC_OPTIMA,
    [DEVICE_COLORS.BLACK]: BLACK_LEFT_RIC_OPTIMA,
    [DEVICE_COLORS.BEIGE]: BEIGE_LEFT_RIC_OPTIMA,
  };

  const RIGHT_EAR_IMAGES_OPTIMA = {
    [DEVICE_COLORS.METALIC]: METALIC_RIGHT_RIC_OPTIMA,
    [DEVICE_COLORS.BLACK]: BLACK_RIGHT_RIC_OPTIMA,
    [DEVICE_COLORS.BEIGE]: BEIGE_RIGHT_RIC_OPTIMA,
  };

  const LEFT_EAR_IMAGES_PRIME = {
    [DEVICE_COLORS.METALIC]: {
      [DOM_TYPE.CLOSE]: RIC_OPTIMA_16_LEFT_CLOSE_MODE_GREY,
      [DOM_TYPE.POWER]: RIC_OPTIMA_16_LEFT_POWER_MODE_GREY,
      [DOM_TYPE.TULIP]: RIC_OPTIMA_16_LEFT_TULIP_MODE_GREY,
      [DOM_TYPE.OPEN]: RIC_OPTIMA_16_LEFT_OPEN_MODE_GREY,
    },
    [DEVICE_COLORS.BEIGE]: {
      [DOM_TYPE.CLOSE]: RIC_OPTIMA_16_LEFT_CLOSE_MODE_BIEGE,
      [DOM_TYPE.POWER]: RIC_OPTIMA_16_LEFT_POWER_MODE_BIEGE,
      [DOM_TYPE.TULIP]: RIC_OPTIMA_16_LEFT_TULIP_MODE_BIEGE,
      [DOM_TYPE.OPEN]: RIC_OPTIMA_16_LEFT_OPEN_MODE_BIEGE,
    },
    [DEVICE_COLORS.BLACK]: {
      [DOM_TYPE.CLOSE]: RIC_OPTIMA_16_LEFT_CLOSE_MODE_BLACK,
      [DOM_TYPE.POWER]: RIC_OPTIMA_16_LEFT_POWER_MODE_BLACK,
      [DOM_TYPE.TULIP]: RIC_OPTIMA_16_LEFT_TULIP_MODE_BLACK,
      [DOM_TYPE.OPEN]: RIC_OPTIMA_16_LEFT_OPEN_MODE_BLACK,
    },
  };

  const RIGHT_EAR_IMAGES_PRIME = {
    [DEVICE_COLORS.METALIC]: {
      [DOM_TYPE.CLOSE]: RIC_OPTIMA_16_RIGHT_CLOSE_MODE_GREY,
      [DOM_TYPE.POWER]: RIC_OPTIMA_16_RIGHT_POWER_MODE_GREY,
      [DOM_TYPE.TULIP]: RIC_OPTIMA_16_RIGHT_TULIP_MODE_GREY,
      [DOM_TYPE.OPEN]: RIC_OPTIMA_16_RIGHT_OPEN_MODE_GREY,
    },
    [DEVICE_COLORS.BEIGE]: {
      [DOM_TYPE.CLOSE]: RIC_OPTIMA_16_RIGHT_CLOSE_MODE_BIEGE,
      [DOM_TYPE.POWER]: RIC_OPTIMA_16_RIGHT_POWER_MODE_BIEGE,
      [DOM_TYPE.TULIP]: RIC_OPTIMA_16_RIGHT_TULIP_MODE_BIEGE,
      [DOM_TYPE.OPEN]: RIC_OPTIMA_16_RIGHT_OPEN_MODE_BIEGE,
    },
    [DEVICE_COLORS.BLACK]: {
      [DOM_TYPE.CLOSE]: RIC_OPTIMA_16_RIGHT_CLOSE_MODE_BLACK,
      [DOM_TYPE.POWER]: RIC_OPTIMA_16_RIGHT_POWER_MODE_BLACK,
      [DOM_TYPE.TULIP]: RIC_OPTIMA_16_RIGHT_TULIP_MODE_BLACK,
      [DOM_TYPE.OPEN]: RIC_OPTIMA_16_RIGHT_OPEN_MODE_BLACK,
    },
  };

  const getLeftEarImage = () => {
    if (
      (device === DEVICES.RIC_OPTIMA || device === DEVICES.RIC_OPTIMA_8) &&
      fields?.left_fitted_device?.device_color &&
      selectedDomeLeft
    ) {
      return (
        LEFT_EAR_IMAGES_PRIME[fields?.left_fitted_device?.device_color][
          selectedDomeLeft
        ] || METALIC_LEFT_RIC_OPTIMA
      );
    } else if (
      device === DEVICES.RIC_PRIME &&
      fields?.left_fitted_device?.device_color &&
      selectedDomeLeft
    ) {
      return (
        LEFT_EAR_IMAGES_PRIME[fields?.left_fitted_device?.device_color][
          selectedDomeLeft
        ] || METALIC_LEFT_RIC_PRIME
      );
    } else if (
      device === DEVICES.RIC_OPTIMA ||
      device === DEVICES.RIC_OPTIMA_8
    ) {
      return LEFT_EAR_IMAGES_PRIME[selectedColorOptima][DOM_TYPE.OPEN];
    }
    return RIGHTIMG;
  };

  const getRightEarImage = () => {
    console.log(
      "this is selectedColorOptima..",
      selectedColorOptima,
      fields?.right_fitted_device?.device_color
    );
    if (
      (device === DEVICES.RIC_OPTIMA || device === DEVICES.RIC_OPTIMA_8) &&
      fields?.right_fitted_device?.device_color &&
      selectedDome
    ) {
      return (
        RIGHT_EAR_IMAGES_PRIME[fields?.right_fitted_device?.device_color][
          selectedDome
        ] || METALIC_RIGHT_RIC_OPTIMA
      );
    } else if (
      device === DEVICES.RIC_PRIME &&
      fields?.right_fitted_device?.device_color &&
      selectedDome
    ) {
      return (
        RIGHT_EAR_IMAGES_PRIME[fields?.right_fitted_device?.device_color][
          selectedDome
        ] || METALIC_RIGHT_RIC_PRIME
      );
    } else if (
      device === DEVICES.RIC_OPTIMA ||
      device === DEVICES.RIC_OPTIMA_8
    ) {
      return RIGHT_EAR_IMAGES_PRIME[selectedColorOptima][DOM_TYPE.OPEN];
    }
    return LEFTIMG;
  };

  const ChartComponent = ({
    rightEar,
    dataB,
    dataA,
    dataC,
    aidedData,
    device,
  }) => {
    const boneImg = new Image();
    if (rightEar) {
      boneImg.src = RIGHTARROWICON;
    } else {
      boneImg.src = LEFTARROWICON;
    }
    boneImg.height = 8;
    boneImg.width = 4;
    const aidedImg = new Image();
    aidedImg.src = LetterAIcon;

    const UclImg = new Image();
    if (rightEar) {
      UclImg.src = ucl_right;
    } else {
      UclImg.src = ucl_left;
    }
    UclImg.height = 16;
    UclImg.width = 16;
    const upperBound =
      device === DEVICES.RIC_OPTIMA || device === DEVICES.RIC_PRIME
        ? [0, 0, 0, 0, 0, 0, 0, 0]
        : [78, 81, 81, 81, 92, 94, 94, 94];

    const lowerBound =
      device === DEVICES.RIC_OPTIMA || device === DEVICES.RIC_PRIME
        ? [80, 80, 80, 90, 90, 90, 90, 90]
        : [-2, -1, 0, 1, 10, 17, 17, 17];

    const data = {
      labels: ["250", "500", "1k", "2k", "4k", "6k", "8k"],
      datasets: [
        {
          label: "Fitting Range AC",
          data: dataA?.map((item) => item),
          borderColor: "#C24747",
          pointBackgroundColor: "white",
          pointStyle: rightEar ? "circle" : "crossRot",
          hoverBorderColor: rightEar ? "#E62323" : "#0000FF",
          borderColor: rightEar ? "#E62323" : "#0000FF",
          radius: rightEar ? 6 : 7,
        },
        {
          label: "Grey Area Upper Bound",
          data: upperBound,
          borderColor: "rgba(0, 0, 0, 0)",
          backgroundColor: "rgba(200, 200, 200, 0.5)",
          pointRadius: 0,
          fill: "+1",
        },
        {
          label: "Grey Area Lower Bound",
          data: lowerBound,
          borderColor: "rgba(0, 0, 0, 0)",
          backgroundColor: "rgba(200, 200, 200, 0)",
          pointRadius: 0,
          fill: "origin",
        },
      ],
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      responsive: true,
      animation: false,
      scales: {
        x: {
          grid: {
            display: true,
          },
          ticks: {
            font: {
              size: 10,
              color: "#666666",
            },
          },
        },
        y: {
          min: -10,
          max: 120,
          reverse: true,
          ticks: {
            callback: function (value) {
              return value;
            },
            stepSize: 10,
            autoSkip: false,
            font: {
              size: 8,
            },
          },
          grid: {
            display: true,
          },
        },
      },
      responsive: true,
      animation: false,
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: false,
        },
        datalabels: {
          display: false,
        },
      },
      elements: {
        line: {
          borderWidth: 1,
          tension: 0.4,
        },
      },
    };
    return (
      <Box
        sx={{
          minHeight: "30vh",
          height: "35vh",
          minWidth: "15vw",
          width: "20vw",
        }}
      >
        <Line data={data} options={options} />
      </Box>
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        height: "100vh",
        flex: 1,
        justifyContent: "flex-start",
        borderTop: "1px solid #DDDDDD",
      }}
    >
      <Grid container spacing={2}>
        <Grid item sm={12} md={12} xs={12}>
          <Box sx={{ width: "100%", height: "84vh" }}>
            <Grid container columnSpacing={2}>
              <Grid
                item
                sm={4}
                md={3.5}
                sx={{
                  minHeight: "85vh",
                  maxWidth: "90vh ",
                  alignItems: "center",
                  borderRight: "1px solid #DDDDDD",
                  fontFamily: "League Spartan",
                  color: "#4D4D4D",
                }}
              >
                <Box>
                  {/* <Typography sx={{ padding: "8px 24px 8px 24px" }}>
                    Fitting History
                  </Typography> */}
                  <Box p={4} sx={{ gap: "5px" }}>
                    <Box>
                      <Accordion
                        expanded={expanded === "panel1"}
                        onChange={handleChange("panel1")}
                      >
                        <AccordionSummary>
                          <Typography
                            sx={{ paddingLeft: "20px", color: "#666" }}
                          >
                            BTE
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid
                            container
                            spacing={2}
                            gap={3}
                            p={3}
                            sx={{ display: "flex", justifyContent: "center" }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                flex: "1",
                                padding: "24px 16px",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: "16px",
                                height: "25vh",
                                maxWidth: "10vw",
                                marginLeft: "5px",
                                borderRadius: "10px",
                                border:
                                  device == DEVICES.BTE_OPTIMA
                                    ? "1px solid #2D3B67"
                                    : "1px solid #DDDDDD",
                                backgroundColor:
                                  device == DEVICES.BTE_OPTIMA && "#EDF0F7",
                              }}
                              onMouseOver={handleMouseOver}
                              onMouseOut={handleMouseOut}
                            >
                              <Box sx={{ alignItems: "center" }}>
                                <Box>
                                  <img
                                    src={BTE}
                                    alt="LeftEar"
                                    style={{ width: "10vw", height: "10vh" }}
                                  />
                                </Box>
                              </Box>
                              <Typography
                                sx={{ textAlign: "center" }}
                                variant="h5"
                                component="div"
                              >
                                BTE OPTIMA
                                {hovered && (
                                  <Grid
                                    mt={2}
                                    container
                                    sx={{
                                      display: "flex",
                                      width: "9vw",
                                      justifyContent: "space-between",
                                      alignItems: "flex-start",
                                    }}
                                  >
                                    <Box
                                      sx={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setSelectDevice(LISTENING_SIDE.RIGHT);
                                        setDevice(DEVICES.BTE_OPTIMA);
                                        setFields({
                                          ...fields,
                                          right_fitted_device: {
                                            ...fields.right_fitted_device,
                                            device_type: DEVICES.BTE_OPTIMA,
                                          },
                                        });
                                      }}
                                    >
                                      <img
                                        src={RIGHT}
                                        alt="RightEar"
                                        style={{
                                          width: "22px",
                                          height: "22px",
                                        }}
                                      />
                                    </Box>
                                    <Box
                                      sx={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setSelectDevice(LISTENING_SIDE.BOTH);
                                        setDevice(DEVICES.BTE_OPTIMA);
                                        setFields({
                                          ...fields,
                                          right_fitted_device: {
                                            ...fields.right_fitted_device,
                                            device_type: DEVICES.BTE_OPTIMA,
                                          },
                                          left_fitted_device: {
                                            ...fields.left_fitted_device,
                                            device_type: DEVICES.BTE_OPTIMA,
                                          },
                                        });
                                      }}
                                    >
                                      <img
                                        src={CENTER}
                                        alt="CenterEar"
                                        style={{
                                          width: "22px",
                                          height: "22px",
                                        }}
                                      />
                                    </Box>
                                    <Box
                                      sx={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setSelectDevice(LISTENING_SIDE.LEFT);
                                        setDevice(DEVICES.BTE_OPTIMA);
                                        setFields({
                                          ...fields,
                                          left_fitted_device: {
                                            ...fields.left_fitted_device,
                                            device_type: DEVICES.BTE_OPTIMA,
                                          },
                                        });
                                      }}
                                    >
                                      <img
                                        src={LEFT}
                                        alt="LeftEar"
                                        style={{
                                          width: "22px",
                                          height: "22px",
                                        }}
                                      />
                                    </Box>
                                  </Grid>
                                )}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                flex: "1",
                                padding: "24px 16px",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: "16px",
                                height: "25vh",
                                maxWidth: "10vw",
                                borderRadius: "10px",
                                border:
                                  device == DEVICES.BTE_PRIME
                                    ? "1px solid #2D3B67"
                                    : "1px solid #DDDDDD",
                                backgroundColor:
                                  device == DEVICES.BTE_PRIME && "#EDF0F7",
                              }}
                              onMouseOver={handleMouseOver1}
                              onMouseOut={handleMouseOut1}
                            >
                              <Box sx={{ alignItems: "center" }}>
                                <Box>
                                  <img
                                    src={BTE}
                                    alt="LeftEar"
                                    style={{ width: "10vw", height: "10vh" }}
                                  />
                                </Box>
                              </Box>
                              <Typography
                                sx={{ textAlign: "center" }}
                                variant="h5"
                                component="div"
                              >
                                BTE PRIME
                                {hovered1 && (
                                  <Box
                                    mt={2}
                                    sx={{
                                      display: "flex",
                                      width: "9vw",
                                      height: "25vh",
                                      justifyContent: "space-between",
                                      alignItems: "flex-start",
                                    }}
                                  >
                                    <Box
                                      sx={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setSelectDevice(LISTENING_SIDE.RIGHT);
                                        setDevice(DEVICES.BTE_PRIME);
                                        setFields({
                                          ...fields,
                                          right_fitted_device: {
                                            ...fields.right_fitted_device,
                                            device_type: DEVICES.BTE_PRIME,
                                          },
                                        });
                                      }}
                                    >
                                      <img
                                        src={RIGHT}
                                        alt="RightEar"
                                        style={{
                                          width: "22px",
                                          height: "22px",
                                        }}
                                      />
                                    </Box>
                                    <Box
                                      sx={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setSelectDevice(LISTENING_SIDE.BOTH);
                                        setDevice(DEVICES.BTE_PRIME);
                                        setFields({
                                          ...fields,
                                          right_fitted_device: {
                                            ...fields.right_fitted_device,
                                            device_type: DEVICES.BTE_PRIME,
                                          },
                                          left_fitted_device: {
                                            ...fields.left_fitted_device,
                                            device_type: DEVICES.BTE_PRIME,
                                          },
                                        });
                                      }}
                                    >
                                      <img
                                        src={CENTER}
                                        alt="CenterEar"
                                        style={{
                                          width: "22px",
                                          height: "22px",
                                        }}
                                      />
                                    </Box>
                                    <Box
                                      sx={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setSelectDevice(LISTENING_SIDE.LEFT);
                                        setDevice(DEVICES.BTE_PRIME);
                                        setFields({
                                          ...fields,
                                          left_fitted_device: {
                                            ...fields.left_fitted_device,
                                            device_type: DEVICES.BTE_PRIME,
                                          },
                                        });
                                      }}
                                    >
                                      <img
                                        src={LEFT}
                                        alt="LeftEar"
                                        style={{
                                          width: "22px",
                                          height: "22px",
                                        }}
                                      />
                                    </Box>
                                  </Box>
                                )}
                              </Typography>
                            </Box>
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                    </Box>
                    <Box mt={2}>
                      <Accordion
                        expanded={expanded === "panel2"}
                        onChange={handleChange("panel2")}
                      >
                        <AccordionSummary>
                          <Typography
                            sx={{ paddingLeft: "20px", color: "#666" }}
                          >
                            RIC
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid
                            container
                            spacing={2}
                            gap={3}
                            p={3}
                            sx={{ display: "flex", justifyContent: "center" }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                padding: "24px 16px",
                                gap: "16px",
                                height: "26vh",
                                maxWidth: "11vw",
                                marginLeft: "5px",
                                borderRadius: "10px",
                                border:
                                  device === DEVICES.RIC_OPTIMA_8
                                    ? "1px solid #2D3B67"
                                    : "1px solid #DDDDDD",
                                backgroundColor:
                                  device === DEVICES.RIC_OPTIMA_8
                                    ? "#EDF0F7"
                                    : "transparent",
                                position: "relative",
                              }}
                              onMouseOver={handleMouseOver4}
                              onMouseOut={handleMouseOut4}
                            >
                              <Box
                                sx={{
                                  position: "absolute",
                                  top: "10px",
                                  right: "6px",
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "8px",
                                }}
                              >
                                {Object.entries({
                                  METALIC: "#C6C1C5",
                                  BLACK: "#000000",
                                  BEIGE: "#D6B19F",
                                }).map(([key, color]) => (
                                  <Box
                                    key={key}
                                    sx={{
                                      width: "16px",
                                      height: "16px",
                                      backgroundColor: color,
                                      borderRadius: "50%",
                                      cursor: "pointer",
                                      outline:
                                        selectedColorOptima ===
                                        DEVICE_COLORS[key]
                                          ? "1px solid black"
                                          : "none",
                                      outlineOffset: "2px",
                                    }}
                                    onClick={() => {
                                      setSelectedColorOptima(
                                        DEVICE_COLORS[key]
                                      );
                                      setFields((prevFields) => ({
                                        ...prevFields,
                                        right_fitted_device: {
                                          ...prevFields.right_fitted_device,
                                          device_color: DEVICE_COLORS[key],
                                        },
                                        left_fitted_device: {
                                          ...prevFields.left_fitted_device,
                                          device_color: DEVICE_COLORS[key],
                                        },
                                      }));
                                    }}
                                  />
                                ))}
                              </Box>
                              <Box sx={{ alignItems: "center" }}>
                                <Box sx={{ alignItems: "center" }}>
                                  <img
                                    src={getRicOptimaImage()}
                                    alt="RIC Optima"
                                    style={{
                                      width: "10vw",
                                      height: "11vh",
                                      marginTop: "10px",
                                    }}
                                  />
                                </Box>
                              </Box>
                              <Typography
                                sx={{ textAlign: "center" }}
                                variant="h5"
                                component="div"
                              >
                                RIC OPTIMA 8
                                {hovered4 && (
                                  <Grid
                                    mt={2}
                                    container
                                    sx={{
                                      display: "flex",
                                      width: "9vw",
                                      justifyContent: "space-between",
                                      alignItems: "flex-start",
                                    }}
                                  >
                                    <Box
                                      sx={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setSelectDevice(LISTENING_SIDE.RIGHT);
                                        setDevice(DEVICES.RIC_OPTIMA_8);
                                        setFields({
                                          ...fields,
                                          right_fitted_device: {
                                            ...fields.right_fitted_device,
                                            device_type: DEVICES.RIC_OPTIMA_8,
                                          },
                                        });
                                      }}
                                    >
                                      <img
                                        src={RIGHT}
                                        alt="RightEar"
                                        style={{
                                          width: "22px",
                                          height: "22px",
                                        }}
                                      />
                                    </Box>
                                    <Box
                                      sx={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setSelectDevice(LISTENING_SIDE.BOTH);
                                        setDevice(DEVICES.RIC_OPTIMA_8);
                                        setFields({
                                          ...fields,
                                          right_fitted_device: {
                                            ...fields.right_fitted_device,
                                            device_type: DEVICES.RIC_OPTIMA_8,
                                          },
                                          left_fitted_device: {
                                            ...fields.left_fitted_device,
                                            device_type: DEVICES.RIC_OPTIMA_8,
                                          },
                                        });
                                      }}
                                    >
                                      <img
                                        src={CENTER}
                                        alt="CenterEar"
                                        style={{
                                          width: "22px",
                                          height: "22px",
                                        }}
                                      />
                                    </Box>
                                    <Box
                                      sx={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setSelectDevice(LISTENING_SIDE.LEFT);
                                        setDevice(DEVICES.RIC_OPTIMA_8);
                                        setFields({
                                          ...fields,
                                          left_fitted_device: {
                                            ...fields.left_fitted_device,
                                            device_type: DEVICES.RIC_OPTIMA_8,
                                          },
                                        });
                                      }}
                                    >
                                      <img
                                        src={LEFT}
                                        alt="LeftEar"
                                        style={{
                                          width: "22px",
                                          height: "22px",
                                        }}
                                      />
                                    </Box>
                                  </Grid>
                                )}
                              </Typography>
                            </Box>

                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                padding: "24px 16px",
                                gap: "16px",
                                height: "26vh",
                                maxWidth: "11vw",
                                marginLeft: "5px",
                                borderRadius: "10px",
                                border:
                                  device === DEVICES.RIC_OPTIMA
                                    ? "1px solid #2D3B67"
                                    : "1px solid #DDDDDD",
                                backgroundColor:
                                  device === DEVICES.RIC_OPTIMA
                                    ? "#EDF0F7"
                                    : "transparent",
                                position: "relative",
                              }}
                              onMouseOver={handleMouseOver5}
                              onMouseOut={handleMouseOut5}
                            >
                              <Box
                                sx={{
                                  position: "absolute",
                                  top: "10px",
                                  right: "6px",
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "8px",
                                }}
                              >
                                {Object.entries({
                                  METALIC: "#C6C1C5",
                                  BLACK: "#000000",
                                  BEIGE: "#D6B19F",
                                }).map(([key, color]) => (
                                  <Box
                                    key={key}
                                    sx={{
                                      width: "16px",
                                      height: "16px",
                                      backgroundColor: color,
                                      borderRadius: "50%",
                                      cursor: "pointer",
                                      outline:
                                        selectedColorOptima ===
                                        DEVICE_COLORS[key]
                                          ? "1px solid black"
                                          : "none",
                                      outlineOffset: "2px",
                                    }}
                                    onClick={() => {
                                      setSelectedColorOptima(
                                        DEVICE_COLORS[key]
                                      );
                                      setFields((prevFields) => ({
                                        ...prevFields,
                                        right_fitted_device: {
                                          ...prevFields.right_fitted_device,
                                          device_color: DEVICE_COLORS[key],
                                        },
                                        left_fitted_device: {
                                          ...prevFields.left_fitted_device,
                                          device_color: DEVICE_COLORS[key],
                                        },
                                      }));
                                    }}
                                  />
                                ))}
                              </Box>
                              <Box sx={{ alignItems: "center" }}>
                                <Box sx={{ alignItems: "center" }}>
                                  <img
                                    src={getRicOptimaImage()}
                                    alt="RIC Optima"
                                    style={{
                                      width: "10vw",
                                      height: "11vh",
                                      marginTop: "10px",
                                    }}
                                  />
                                </Box>
                              </Box>
                              <Typography
                                sx={{ textAlign: "center" }}
                                variant="h5"
                                component="div"
                              >
                                RIC OPTIMA 16
                                {hovered5 && (
                                  <Grid
                                    mt={2}
                                    container
                                    sx={{
                                      display: "flex",
                                      width: "9vw",
                                      justifyContent: "space-between",
                                      alignItems: "flex-start",
                                    }}
                                  >
                                    <Box
                                      sx={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setSelectDevice(LISTENING_SIDE.RIGHT);
                                        setDevice(DEVICES.RIC_OPTIMA);
                                        setFields({
                                          ...fields,
                                          right_fitted_device: {
                                            ...fields.right_fitted_device,
                                            device_type: DEVICES.RIC_OPTIMA,
                                          },
                                        });
                                      }}
                                    >
                                      <img
                                        src={RIGHT}
                                        alt="RightEar"
                                        style={{
                                          width: "22px",
                                          height: "22px",
                                        }}
                                      />
                                    </Box>
                                    <Box
                                      sx={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setSelectDevice(LISTENING_SIDE.BOTH);
                                        setDevice(DEVICES.RIC_OPTIMA);
                                        setFields({
                                          ...fields,
                                          right_fitted_device: {
                                            ...fields.right_fitted_device,
                                            device_type: DEVICES.RIC_OPTIMA,
                                          },
                                          left_fitted_device: {
                                            ...fields.left_fitted_device,
                                            device_type: DEVICES.RIC_OPTIMA,
                                          },
                                        });
                                      }}
                                    >
                                      <img
                                        src={CENTER}
                                        alt="CenterEar"
                                        style={{
                                          width: "22px",
                                          height: "22px",
                                        }}
                                      />
                                    </Box>
                                    <Box
                                      sx={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setSelectDevice(LISTENING_SIDE.LEFT);
                                        setDevice(DEVICES.RIC_OPTIMA);
                                        setFields({
                                          ...fields,
                                          left_fitted_device: {
                                            ...fields.left_fitted_device,
                                            device_type: DEVICES.RIC_OPTIMA,
                                          },
                                        });
                                      }}
                                    >
                                      <img
                                        src={LEFT}
                                        alt="LeftEar"
                                        style={{
                                          width: "22px",
                                          height: "22px",
                                        }}
                                      />
                                    </Box>
                                  </Grid>
                                )}
                              </Typography>
                            </Box>
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                    </Box>
                    {/* <Box mt={2}>
                      <Accordion
                        expanded={expanded === "panel3"}
                        onChange={handleChange("panel3")}
                      >
                        <AccordionSummary>
                          <Typography
                            sx={{ paddingLeft: "20px", color: "#666" }}
                          >
                            SPECTACLES{" "}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: "16px",
                                height: "23vh",
                                maxWidth: "10vw",
                                marginLeft: "5px",
                                borderRadius: "10px",
                                border:
                                  device == DEVICES.RIC_OPTIMA
                                    ? "1px solid #2D3B67"
                                    : "1px solid #DDDDDD",
                                backgroundColor:
                                  device == DEVICES.RIC_OPTIMA && "#EDF0F7",
                              }}
                              onMouseOver={handleMouseOver2}
                              onMouseOut={handleMouseOut2}
                            >
                              <Box sx={{ height: "70px", width: "160px" }}>
                                <img
                                  src={SPECS}
                                  alt="LeftEar"
                                  style={{ width: "160px", height: "80px" }}
                                />
                              </Box>

                              <Typography variant="h6">SPECS</Typography>
                              {hovered2 && (
                                <Box
                                  sx={{
                                    display: "flex",
                                    width: "8vw",
                                    height: "18vh",
                                    justifyContent: "space-between",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  <Box
                                    sx={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setSelectDevice(LISTENING_SIDE.RIGHT);
                                      setDevice(DEVICES.BTE_PRIME);
                                      setFields({
                                        ...fields,
                                        right_fitted_device: {
                                          ...fields.right_fitted_device,
                                          device_type: DEVICES.BTE_PRIME,
                                        },
                                      });
                                    }}
                                  >
                                    <img
                                      src={RIGHT}
                                      alt="RightEar"
                                      style={{
                                        width: "22px",
                                        height: "22px",
                                      }}
                                    />
                                  </Box>
                                  <Box
                                    sx={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setSelectDevice(LISTENING_SIDE.BOTH);
                                      setDevice(DEVICES.BTE_PRIME);
                                      setFields({
                                        ...fields,
                                        right_fitted_device: {
                                          ...fields.right_fitted_device,
                                          device_type: DEVICES.BTE_PRIME,
                                        },
                                        left_fitted_device: {
                                          ...fields.left_fitted_device,
                                          device_type: DEVICES.BTE_PRIME,
                                        },
                                      });
                                    }}
                                  >
                                    <img
                                      src={CENTER}
                                      alt="CenterEar"
                                      style={{
                                        width: "22px",
                                        height: "22px",
                                      }}
                                    />
                                  </Box>
                                  <Box
                                    sx={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setSelectDevice(LISTENING_SIDE.LEFT);
                                      setDevice(DEVICES.BTE_PRIME);
                                      setFields({
                                        ...fields,
                                        left_fitted_device: {
                                          ...fields.left_fitted_device,
                                          device_type: DEVICES.BTE_PRIME,
                                        },
                                      });
                                    }}
                                  >
                                    <img
                                      src={LEFT}
                                      alt="LeftEar"
                                      style={{
                                        width: "22px",
                                        height: "22px",
                                      }}
                                    />
                                  </Box>
                                </Box>
                              )}
                            </Box>
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                    </Box>
                    <Box mt={2}>
                      <Accordion>
                        <AccordionSummary>
                          <Typography
                            sx={{ paddingLeft: "20px", color: "#666" }}
                          >
                            HEARNU PRO
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography></Typography>
                        </AccordionDetails>
                      </Accordion>
                    </Box> */}
                  </Box>
                </Box>
              </Grid>

              <Grid
                md={8.5}
                sm={8}
                sx={{
                  overflow: "auto",
                  scrollbarWidth: "none",
                  height: "90vh",
                }}
              >
                <Stack
                  direction={"row"}
                  sx={{ maxWidth: "100% ", fontFamily: "League Spartan" }}
                >
                  {(selectDevice === LISTENING_SIDE.RIGHT ||
                    selectDevice === LISTENING_SIDE.BOTH) && (
                    <Box
                      mb={2}
                      sx={{
                        height: "100%",
                        minWidth:
                          selectDevice == LISTENING_SIDE.BOTH ? "50%" : "100%",
                        fontFamily: "League Spartan",
                      }}
                    >
                      <Box ml={3}>
                        <img
                          src={RIGHT}
                          alt="RightEar"
                          style={{
                            width: "22px",
                            height: "22px",
                            padding: "3px",
                          }}
                        />
                        <Typography
                          variant="h4"
                          sx={{
                            color:
                              selectDevice === LISTENING_SIDE.RIGHT ||
                              selectDevice === LISTENING_SIDE.BOTH
                                ? "#C24747"
                                : "#1265A1",
                            fontFamily: "League Spartan",
                            fontWeight: "500",
                            marginLeft: "20px",
                            listStyleType: "disc",
                          }}
                        >
                          {device === DEVICES.BTE_OPTIMA
                            ? "BTE OPTIMA"
                            : device === DEVICES.BTE_PRIME
                            ? "BTE PRIME"
                            : device === DEVICES.RIC_OPTIMA
                            ? "RIC OPTIMA 16"
                            : device === DEVICES.RIC_OPTIMA_8
                            ? "RIC OPTIMA 8"
                            : ""}
                          <Button
                            onClick={() => {
                              setFields((prevFields) => ({
                                ...prevFields,
                                right_fitted_device: {
                                  device_tube: null,
                                  device_channel:
                                    prevFields.right_fitted_device
                                      .device_channel,
                                  dom_type: null,
                                  dom_size: null,
                                  device_side: LISTENING_SIDE.RIGHT,
                                  selected: false,
                                  device_type:
                                    prevFields.right_fitted_device.device_type,
                                },
                              }));
                              setSelectedDome(null);
                              setSelectedTube(null);
                            }}
                          >
                            <img
                              src={cancel}
                              style={{
                                width: "25px",
                                height: "25px",
                              }}
                            />
                          </Button>
                        </Typography>
                      </Box>
                      <Grid
                        container
                        sx={{
                          display: "flex",
                          justifyContent:
                            selectDevice === LISTENING_SIDE.BOTH
                              ? "space-around"
                              : "flex-start",
                        }}
                      >
                        <Stack
                          sx={{
                            display: "flex",
                            direction: "column",
                            paddingLeft:
                              selectDevice === LISTENING_SIDE.BOTH
                                ? ""
                                : "35px",
                          }}
                        >
                          {!(
                            device == DEVICES.RIC_OPTIMA ||
                            device == DEVICES.RIC_OPTIMA_8
                          ) && (
                            <Box>
                              <Typography
                                variant="h6"
                                sx={{
                                  color: "#666666",
                                  fontFamily: "League Spartan",
                                  fontWeight: "500",
                                  marginTop:
                                    selectDevice === LISTENING_SIDE.BOTH
                                      ? "0px"
                                      : "20px",
                                  listStyleType: "disc",
                                }}
                              >
                                Tube
                              </Typography>
                            </Box>
                          )}
                          {!(
                            device == DEVICES.RIC_OPTIMA ||
                            device == DEVICES.RIC_OPTIMA_8
                          ) && (
                            <Grid
                              container
                              gap={"7px"}
                              sx={{
                                display: "flex",
                                justifyContent:
                                  selectDevice === LISTENING_SIDE.BOTH
                                    ? "flex-end"
                                    : "",
                                marginTop: "5px",
                              }}
                            >
                              <Button
                                onClick={() =>
                                  handleTubeClickRight(DEVICES_TUBE.STANDARD)
                                }
                                sx={{
                                  fontSize: "14px",
                                  width: "83px",
                                  height: "35px",
                                  backgroundColor:
                                    selectedTube === DEVICES_TUBE.STANDARD
                                      ? "#EDF0F7"
                                      : "white",
                                  border:
                                    selectedTube === DEVICES_TUBE.STANDARD
                                      ? "1px solid #2D3B67"
                                      : "1px solid #CCCCCC",
                                }}
                              >
                                <Typography variant="h6">Standard</Typography>
                              </Button>
                              <Button
                                onClick={() =>
                                  handleTubeClickRight(DEVICES_TUBE.THIN)
                                }
                                sx={{
                                  fontSize: "16px",
                                  width: "83px",
                                  height: "35px",
                                  backgroundColor:
                                    selectedTube === DEVICES_TUBE.THIN
                                      ? "#EDF0F7"
                                      : "white",
                                  border:
                                    selectedTube === DEVICES_TUBE.THIN
                                      ? "1px solid #2D3B67"
                                      : "1px solid #CCCCCC",
                                }}
                              >
                                <Typography variant="h6">Thin</Typography>
                              </Button>
                            </Grid>
                          )}
                          <Box>
                            <Typography
                              variant="h6"
                              sx={{
                                color: "#666666",
                                fontFamily: "League Spartan",
                                fontWeight: "500",
                                display: "flex",
                                justifyContent: "flex-start",
                              }}
                            >
                              Dome
                            </Typography>
                          </Box>
                          <Stack
                            gap={2}
                            direction={
                              selectDevice === LISTENING_SIDE.BOTH
                                ? "column"
                                : "row"
                            }
                          >
                            <Stack
                              direction={"row"}
                              container
                              gap={"7px"}
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Button
                                onClick={() =>
                                  handleDomeClickRight(DOM_TYPE.OPEN)
                                }
                                sx={{
                                  fontSize: "16px",
                                  width: "83px",
                                  height: "35px",
                                  backgroundColor:
                                    selectedDome === DOM_TYPE.OPEN
                                      ? "#EDF0F7"
                                      : "white",
                                  border:
                                    selectedDome === DOM_TYPE.OPEN
                                      ? "1px solid #2D3B67"
                                      : "1px solid #CCCCCC",
                                }}
                              >
                                <Typography variant="h6">Open</Typography>
                              </Button>
                              <Button
                                onClick={() =>
                                  handleDomeClickRight(DOM_TYPE.CLOSE)
                                }
                                sx={{
                                  fontSize: "16px",
                                  width: "83px",
                                  height: "35px",
                                  backgroundColor:
                                    selectedDome === DOM_TYPE.CLOSE
                                      ? "#EDF0F7"
                                      : "white",
                                  border:
                                    selectedDome === DOM_TYPE.CLOSE
                                      ? "1px solid #2D3B67"
                                      : "1px solid #CCCCCC",
                                }}
                              >
                                <Typography variant="h6">Close</Typography>
                              </Button>
                            </Stack>
                            <Stack
                              direction={"row"}
                              gap={"7px"}
                              display={"flex"}
                              justifyContent={"flex-end"}
                            >
                              <Button
                                onClick={() =>
                                  handleDomeClickRight(DOM_TYPE.POWER)
                                }
                                sx={{
                                  fontSize: "16px",
                                  width: "83px",
                                  height: "35px",
                                  backgroundColor:
                                    selectedDome === DOM_TYPE.POWER
                                      ? "#EDF0F7"
                                      : "white",
                                  border:
                                    selectedDome === DOM_TYPE.POWER
                                      ? "1px solid #2D3B67"
                                      : "1px solid #CCCCCC",
                                }}
                              >
                                <Typography variant="h6">Power</Typography>
                              </Button>

                              {(device === DEVICES.RIC_OPTIMA ||
                                device === DEVICES.RIC_OPTIMA_8) && (
                                <Button
                                  onClick={() =>
                                    handleDomeClickRight(DOM_TYPE.TULIP)
                                  }
                                  sx={{
                                    fontSize: "15px",
                                    width: "83px",
                                    height: "35px",
                                    paddingLeft: "5px",
                                    paddingRight: "5px",
                                    backgroundColor:
                                      selectedDome === DOM_TYPE.TULIP
                                        ? "#EDF0F7"
                                        : "white",
                                    border:
                                      selectedDome === DOM_TYPE.TULIP
                                        ? "1px solid #2D3B67"
                                        : "1px solid #CCCCCC",
                                  }}
                                >
                                  <Typography variant="h6">Tulip</Typography>
                                </Button>
                              )}

                              {!(
                                device === DEVICES.RIC_OPTIMA ||
                                device === DEVICES.RIC_OPTIMA_8
                              ) && (
                                <Button
                                  onClick={() =>
                                    handleDomeClickRight(DOM_TYPE.EAR_MOLD)
                                  }
                                  sx={{
                                    fontSize: "15px",
                                    width: "83px",
                                    height: "35px",
                                    paddingLeft: "5px",
                                    paddingRight: "5px",
                                    backgroundColor:
                                      selectedDome === DOM_TYPE.EAR_MOLD
                                        ? "#EDF0F7"
                                        : "white",
                                    border:
                                      selectedDome === DOM_TYPE.EAR_MOLD
                                        ? "1px solid #2D3B67"
                                        : "1px solid #CCCCCC",
                                  }}
                                >
                                  <Typography variant="h6">Ear-mold</Typography>
                                </Button>
                              )}
                            </Stack>
                          </Stack>
                        </Stack>
                        <Stack
                          mt={5}
                          sx={{ display: "flex", justifyContent: "flex-start" }}
                        >
                          <img
                            src={getRightEarImage()}
                            alt="RightEar"
                            style={{ minWidth: "10vw", maxHeight: "20vh" }}
                          />
                        </Stack>
                      </Grid>
                    </Box>
                  )}

                  {selectDevice === LISTENING_SIDE.BOTH && (
                    <Box sx={{ maxHeight: "100%" }}>
                      <Divider orientation="vertical" />
                    </Box>
                  )}

                  {(selectDevice === LISTENING_SIDE.LEFT ||
                    selectDevice === LISTENING_SIDE.BOTH) && (
                    <Box
                      mb={1}
                      sx={{
                        height: "100%",
                        minWidth:
                          selectDevice == LISTENING_SIDE.BOTH ? "50%" : "100%",
                        fontFamily: "League Spartan",
                      }}
                    >
                      <Box ml={3}>
                        <img
                          src={LEFT}
                          alt="LeftEar"
                          style={{
                            marginTop: "2px",
                            width: "15px",
                            height: "15px",
                          }}
                        />
                        <Typography
                          variant="h4"
                          sx={{
                            color:
                              selectDevice === LISTENING_SIDE.LEFT ||
                              selectDevice === LISTENING_SIDE.BOTH
                                ? "#1265A1"
                                : "#C24747",
                            fontFamily: "League Spartan",
                            fontWeight: "500",
                            marginLeft: "20px",
                          }}
                        >
                          {device === DEVICES.BTE_OPTIMA
                            ? "BTE OPTIMA"
                            : device === DEVICES.BTE_PRIME
                            ? "BTE PRIME"
                            : device === DEVICES.RIC_OPTIMA
                            ? "RIC OPTIMA 16"
                            : device === DEVICES.RIC_OPTIMA_8
                            ? "RIC OPTIMA 8"
                            : ""}
                          <Button
                            onClick={() => {
                              setFields((prevFields) => ({
                                ...prevFields,
                                left_fitted_device: {
                                  device_tube: null,
                                  device_channel:
                                    prevFields.left_fitted_device
                                      .device_channel,
                                  dom_type: null,
                                  dom_size: DOM_SIZE.SMALL,
                                  device_side: LISTENING_SIDE.LEFT,
                                  selected: false,
                                  device_type:
                                    prevFields.left_fitted_device.device_type,
                                },
                              }));
                              setSelectedDomeLeft(null);
                              setSelectedTubeLeft(null);
                            }}
                          >
                            <img
                              src={cancel}
                              style={{
                                width: "25px",
                                height: "25px",
                              }}
                            />
                          </Button>
                        </Typography>
                      </Box>
                      <Grid
                        container
                        sx={{
                          display: "flex",
                          justifyContent:
                            selectDevice === LISTENING_SIDE.BOTH
                              ? "space-around"
                              : "",
                        }}
                      >
                        <Stack
                          sx={{
                            display: "flex",
                            marginTop:
                              selectDevice === LISTENING_SIDE.BOTH
                                ? "31px"
                                : "30px",
                            paddingLeft:
                              selectDevice === LISTENING_SIDE.BOTH
                                ? ""
                                : "27px",
                          }}
                        >
                          <img
                            src={getLeftEarImage()}
                            alt="LeftEar"
                            style={{ minWidth: "10vw", maxHeight: "20vh" }}
                          />
                        </Stack>
                        <Stack sx={{ display: "flex", direction: "column" }}>
                          {!(
                            device == DEVICES.RIC_OPTIMA ||
                            device == DEVICES.RIC_OPTIMA_8
                          ) && (
                            <Box>
                              <Typography
                                variant="h6"
                                sx={{
                                  color: "#666666",
                                  fontFamily: "League Spartan",
                                  fontWeight: "500",
                                  marginTop:
                                    selectDevice === LISTENING_SIDE.BOTH
                                      ? "7px"
                                      : "20px",
                                  listStyleType: "disc",
                                }}
                              >
                                Tube
                              </Typography>
                            </Box>
                          )}

                          {!(
                            device == DEVICES.RIC_OPTIMA ||
                            device == DEVICES.RIC_OPTIMA_8
                          ) && (
                            <Grid
                              container
                              gap={"7px"}
                              sx={{
                                display: "flex",
                                justifyContent:
                                  selectDevice === LISTENING_SIDE.BOTH
                                    ? "flex-end"
                                    : "",
                                marginTop: "5px",
                              }}
                            >
                              <Button
                                onClick={() =>
                                  handleTubeClickLeft(DEVICES_TUBE.STANDARD)
                                }
                                sx={{
                                  fontSize: "14px",
                                  width: "83px",
                                  height: "35px",
                                  backgroundColor:
                                    selectedTubeLeft === DEVICES_TUBE.STANDARD
                                      ? "#EDF0F7"
                                      : "white",
                                  border:
                                    selectedTubeLeft === DEVICES_TUBE.STANDARD
                                      ? "1px solid #2D3B67"
                                      : "1px solid #CCCCCC",
                                }}
                              >
                                <Typography variant="h6">Standard</Typography>
                              </Button>
                              <Button
                                onClick={() =>
                                  handleTubeClickLeft(DEVICES_TUBE.THIN)
                                }
                                sx={{
                                  fontSize: "16px",
                                  width: "83px",
                                  height: "35px",
                                  backgroundColor:
                                    selectedTubeLeft === DEVICES_TUBE.THIN
                                      ? "#EDF0F7"
                                      : "white",
                                  border:
                                    selectedTubeLeft === DEVICES_TUBE.THIN
                                      ? "1px solid #2D3B67"
                                      : "1px solid #CCCCCC",
                                }}
                              >
                                <Typography variant="h6">Thin</Typography>
                              </Button>
                            </Grid>
                          )}
                          <Box>
                            <Typography
                              variant="h6"
                              sx={{
                                color: "#666666",
                                fontFamily: "League Spartan",
                                fontWeight: "500",
                                display: "flex",
                                justifyContent: "flex-start",
                              }}
                            >
                              Dome
                            </Typography>
                          </Box>
                          <Stack
                            gap={2}
                            direction={
                              selectDevice === LISTENING_SIDE.BOTH
                                ? "column"
                                : "row"
                            }
                          >
                            <Stack
                              direction={"row"}
                              container
                              gap={"7px"}
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Button
                                onClick={() =>
                                  handleDomeClickLeft(DOM_TYPE.OPEN)
                                }
                                sx={{
                                  fontSize: "14px",
                                  width: "83px",
                                  height: "35px",
                                  backgroundColor:
                                    selectedDomeLeft === DOM_TYPE.OPEN
                                      ? "#EDF0F7"
                                      : "white",
                                  border:
                                    selectedDomeLeft === DOM_TYPE.OPEN
                                      ? "1px solid #2D3B67"
                                      : "1px solid #CCCCCC",
                                }}
                              >
                                <Typography variant="h6">Open</Typography>
                              </Button>
                              <Button
                                onClick={() =>
                                  handleDomeClickLeft(DOM_TYPE.CLOSE)
                                }
                                sx={{
                                  fontSize: "16px",
                                  width: "83px",
                                  height: "35px",
                                  backgroundColor:
                                    selectedDomeLeft === DOM_TYPE.CLOSE
                                      ? "#EDF0F7"
                                      : "white",
                                  border:
                                    selectedDomeLeft === DOM_TYPE.CLOSE
                                      ? "1px solid #2D3B67"
                                      : "1px solid #CCCCCC",
                                }}
                              >
                                <Typography variant="h6">Close</Typography>
                              </Button>
                            </Stack>
                            <Stack
                              direction={"row"}
                              gap={"7px"}
                              display={"flex"}
                              justifyContent={"flex-end"}
                            >
                              <Button
                                onClick={() =>
                                  handleDomeClickLeft(DOM_TYPE.POWER)
                                }
                                sx={{
                                  fontSize: "16px",
                                  width: "83px",
                                  height: "35px",
                                  backgroundColor:
                                    selectedDomeLeft === DOM_TYPE.POWER
                                      ? "#EDF0F7"
                                      : "white",
                                  border:
                                    selectedDomeLeft === DOM_TYPE.POWER
                                      ? "1px solid #2D3B67"
                                      : "1px solid #CCCCCC",
                                }}
                              >
                                <Typography variant="h6">Power</Typography>
                              </Button>

                              {(device == DEVICES.RIC_OPTIMA ||
                                device == DEVICES.RIC_OPTIMA_8) && (
                                <Button
                                  onClick={() =>
                                    handleDomeClickLeft(DOM_TYPE.TULIP)
                                  }
                                  sx={{
                                    fontSize: "15px",
                                    width: "83px",
                                    height: "35px",
                                    paddingLeft: "5px",
                                    backgroundColor:
                                      selectedDomeLeft === DOM_TYPE.TULIP
                                        ? "#EDF0F7"
                                        : "white",
                                    border:
                                      selectedDomeLeft === DOM_TYPE.TULIP
                                        ? "1px solid #2D3B67"
                                        : "1px solid #CCCCCC",
                                  }}
                                >
                                  <Typography variant="h6">Tulip</Typography>
                                </Button>
                              )}

                              {!(
                                device == DEVICES.RIC_OPTIMA ||
                                device == DEVICES.RIC_OPTIMA_8
                              ) && (
                                <Button
                                  onClick={() =>
                                    handleDomeClickLeft(DOM_TYPE.EAR_MOLD)
                                  }
                                  sx={{
                                    fontSize: "15px",
                                    width: "83px",
                                    height: "35px",
                                    paddingLeft: "5px",
                                    backgroundColor:
                                      selectedDomeLeft === DOM_TYPE.EAR_MOLD
                                        ? "#EDF0F7"
                                        : "white",
                                    border:
                                      selectedDomeLeft === DOM_TYPE.EAR_MOLD
                                        ? "1px solid #2D3B67"
                                        : "1px solid #CCCCCC",
                                  }}
                                >
                                  <Typography variant="h6">Ear-mold</Typography>
                                </Button>
                              )}
                            </Stack>
                          </Stack>
                        </Stack>
                      </Grid>
                    </Box>
                  )}
                </Stack>
                {(selectDevice === LISTENING_SIDE.LEFT ||
                  selectDevice === LISTENING_SIDE.RIGHT ||
                  selectDevice === LISTENING_SIDE.BOTH) && (
                  <Box
                    sx={{
                      height: "0vh",
                    }}
                  >
                    <Grid container>
                      <Grid
                        sm={6}
                        p={2}
                        md={6}
                        sx={{
                          borderTop: "1px solid #DDDDDD",
                        }}
                      >
                        {selectDevice === LISTENING_SIDE.BOTH ? (
                          <>
                            <Tabs
                              value={values}
                              onChange={handleChangeTab}
                              aria-label="basic tabs example"
                              sx={{ height: "0px" }}
                            >
                              <Tab
                                label="Features"
                                sx={{ fontSize: "16px" }}
                                {...a11yProps(0)}
                              />
                              <Tab
                                label="Fitting Range"
                                sx={{ fontSize: "16px" }}
                                {...a11yProps(1)}
                              />
                            </Tabs>
                            <CustomTabPanel
                              value={values}
                              index={1}
                              sx={{ height: "0px" }}
                            >
                              <Box
                                // p={4}
                                sx={{
                                  display: "flex",
                                  width: "80%",
                                  height: "35vh",
                                  minHeight: "20vh",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  scrollbarWidth: "none",
                                  overflow: "auto",
                                }}
                              >
                                <ChartComponent
                                  rightEar
                                  device={device}
                                  allowed_ac={fields?.allowed_ac}
                                  allowed_bc={fields?.allowed_bc}
                                  allowed_ucl={fields?.allowed_ucl}
                                  dataA={[
                                    fields?.rf1,
                                    fields?.rf2,
                                    fields?.rf3,
                                    fields?.rf4,
                                    fields?.rf5,
                                    fields?.rf6,
                                    fields?.rf7,
                                  ]}
                                  dataB={[
                                    fields?.brf1,
                                    fields?.brf2,
                                    fields?.brf3,
                                    fields?.brf4,
                                    fields?.brf5,
                                    fields?.brf6,
                                    fields?.brf7,
                                  ]}
                                  dataC={[
                                    fields?.urf1,
                                    fields?.urf2,
                                    fields?.urf3,
                                    fields?.urf4,
                                    fields?.urf5,
                                    fields?.urf6,
                                    fields?.urf7,
                                  ]}
                                />{" "}
                              </Box>
                            </CustomTabPanel>
                            <CustomTabPanel
                              value={values}
                              index={0}
                              sx={{ height: "0px" }}
                            >
                              <List
                                sx={{
                                  listStyleType: "disc",
                                  overflow: "auto",
                                  height: "38vh",
                                  scrollbarWidth: "none",
                                }}
                              >
                                <Box ml={6} component={"div"}>
                                  {getDeviceFeatures().map((feature, index) => (
                                    <ListItem
                                      key={index}
                                      sx={{ display: "list-item" }}
                                    >
                                      <Typography>{feature}</Typography>
                                    </ListItem>
                                  ))}
                                </Box>
                              </List>
                            </CustomTabPanel>
                          </>
                        ) : (
                          <>
                            <Tabs
                              sx={{
                                borderBottom: 1,
                                borderColor: "divider",
                                width: "500px",
                                tabSize: "10px",
                              }}
                              value={value}
                            >
                              <Tab
                                value={value}
                                sx={{ fontSize: "16px" }}
                                label="Features"
                              />
                            </Tabs>

                            <List
                              sx={{
                                listStyleType: "disc",
                                overflow: "auto",
                                height: "38vh",
                                scrollbarWidth: "none",
                              }}
                            >
                              <Box ml={6} component={"div"}>
                                {getDeviceFeatures().map((feature, index) => (
                                  <ListItem
                                    key={index}
                                    sx={{ display: "list-item" }}
                                  >
                                    <Typography>{feature}</Typography>
                                  </ListItem>
                                ))}
                              </Box>
                            </List>
                          </>
                        )}
                      </Grid>

                      <Grid
                        sm={6}
                        p={2}
                        md={6}
                        xs={2}
                        sx={{
                          borderLeft: "1px solid #DDDDDD",
                          borderTop: "1px solid #DDDDDD",
                          overflow: "hidden",
                          minHeight: "55vh",
                        }}
                      >
                        {selectDevice === LISTENING_SIDE.BOTH ? (
                          <>
                            <Tabs
                              value={values1}
                              onChange={handleChangeTab1}
                              aria-label="basic tabs example"
                              sx={{ height: "0px" }}
                            >
                              <Tab
                                label="Features"
                                sx={{ fontSize: "16px" }}
                                {...a11yProps(0)}
                              />
                              <Tab
                                label="Fitting Range"
                                sx={{ fontSize: "16px" }}
                                {...a11yProps(1)}
                              />
                            </Tabs>
                            <CustomTabPanel
                              value={values1}
                              index={1}
                              sx={{ height: "0px" }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  width: "80%",
                                  height: "35vh",
                                  minHeight: "20vh",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  scrollbarWidth: "none",
                                  overflow: "auto",
                                }}
                              >
                                <ChartComponent
                                  device={device}
                                  allowed_ac={fields?.allowed_ac}
                                  allowed_bc={fields?.allowed_bc}
                                  allowed_ucl={fields?.allowed_ucl}
                                  dataA={[
                                    fields?.lf1,
                                    fields?.lf2,
                                    fields?.lf3,
                                    fields?.lf4,
                                    fields?.lf5,
                                    fields?.lf6,
                                    fields?.lf7,
                                  ]}
                                  dataB={[
                                    fields?.blf1,
                                    fields?.blf2,
                                    fields?.blf3,
                                    fields?.blf4,
                                    fields?.blf5,
                                    fields?.blf6,
                                    fields?.blf7,
                                  ]}
                                  dataC={[
                                    fields?.ulf1,
                                    fields?.ulf2,
                                    fields?.ulf3,
                                    fields?.ulf4,
                                    fields?.ulf5,
                                    fields?.ulf6,
                                    fields?.ulf7,
                                  ]}
                                />
                              </Box>
                            </CustomTabPanel>
                            <CustomTabPanel value={values1} index={0}>
                              <List
                                sx={{
                                  listStyleType: "disc",
                                  overflow: "auto",
                                  height: "38vh",
                                  scrollbarWidth: "none",
                                }}
                              >
                                <Box ml={6} component={"div"}>
                                  {getDeviceFeatures().map((feature, index) => (
                                    <ListItem
                                      key={index}
                                      sx={{ display: "list-item" }}
                                    >
                                      <Typography>{feature}</Typography>
                                    </ListItem>
                                  ))}
                                </Box>
                              </List>
                            </CustomTabPanel>
                          </>
                        ) : (
                          <>
                            <Tabs
                              sx={{
                                borderBottom: 1,
                                borderColor: "divider",
                                width: "500px",
                              }}
                              value={value}
                            >
                              <Tab
                                sx={{ fontSize: "16px" }}
                                label="Fitting Range"
                              />
                            </Tabs>
                            <Box
                              p={4}
                              sx={{
                                display: "flex",
                                width: "80%",
                                height: "40vh",
                                alignItems: "center",
                                justifyContent: "center",
                                overflow: "auto",
                                scrollbarWidth: "none",
                              }}
                            >
                              {selectDevice === LISTENING_SIDE.RIGHT ? (
                                <ChartComponent
                                  device={device}
                                  allowed_ac={fields?.allowed_ac}
                                  allowed_bc={fields?.allowed_bc}
                                  allowed_ucl={fields?.allowed_ucl}
                                  dataA={[
                                    fields?.rf1,
                                    fields?.rf2,
                                    fields?.rf3,
                                    fields?.rf4,
                                    fields?.rf5,
                                    fields?.rf6,
                                    fields?.rf7,
                                  ]}
                                  dataB={[
                                    fields?.brf1,
                                    fields?.brf2,
                                    fields?.brf3,
                                    fields?.brf4,
                                    fields?.brf5,
                                    fields?.brf6,
                                    fields?.brf7,
                                  ]}
                                  dataC={[
                                    fields?.urf1,
                                    fields?.urf2,
                                    fields?.urf3,
                                    fields?.urf4,
                                    fields?.urf5,
                                    fields?.urf6,
                                    fields?.urf7,
                                  ]}
                                  rightEar
                                />
                              ) : (
                                <ChartComponent
                                  device={device}
                                  allowed_ac={fields?.allowed_ac}
                                  allowed_bc={fields?.allowed_bc}
                                  allowed_ucl={fields?.allowed_ucl}
                                  dataA={[
                                    fields?.lf1,
                                    fields?.lf2,
                                    fields?.lf3,
                                    fields?.lf4,
                                    fields?.lf5,
                                    fields?.lf6,
                                    fields?.lf7,
                                  ]}
                                  dataB={[
                                    fields?.blf1,
                                    fields?.blf2,
                                    fields?.blf3,
                                    fields?.blf4,
                                    fields?.blf5,
                                    fields?.blf6,
                                    fields?.blf7,
                                  ]}
                                  dataC={[
                                    fields?.ulf1,
                                    fields?.ulf2,
                                    fields?.ulf3,
                                    fields?.ulf4,
                                    fields?.ulf5,
                                    fields?.ulf6,
                                    fields?.ulf7,
                                  ]}
                                />
                              )}
                            </Box>
                          </>
                        )}
                      </Grid>
                    </Grid>
                  </Box>
                )}
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SelectDeviceui;
